import { useContext } from 'react';
import { Handle, Position, useReactFlow } from '@xyflow/react';
import { WorkflowContext } from "../../../context/WorkflowContextProvider";
import SettingsIcon from '@mui/icons-material/Settings';
import CheckIcon from "@mui/icons-material/Check";

function WorkflowHTTPNode({ id, data }) {
    const context = useContext(WorkflowContext);
    const reactFlowInstance = useReactFlow();

    function handleShowHTTPConfigurationClick() {
        const node = reactFlowInstance.getNode(id);
        context.setActiveEditHttpNode(node);
    }

    let type: string = '';
    if (data.type !== undefined) {
        type = data.type;
    }

    let url: string = '';
    if (data.url !== undefined) {
        url = data.url;
        if (url.length > 15) {
            url = url.substring(0, 15) + '...';
        }
    }

    function successfulTest(): string {
        let returnValue: string = '';
        if (!!context.testComplete.includes(id)) {
            returnValue = ' test-success'
        }

        if (!!context.testProcessing.includes(id)) {
            returnValue = ' test-processing'
        }

        if (!!context.testErrored.includes(id)) {
            returnValue = ' test-error';
        }

        return returnValue;
    }

    return (
        <div className={ "workflow-node http " + id + " "  + (successfulTest()) }>
            { (successfulTest() !== '') &&
                <div className={ successfulTest() + "-icon" } />
            }
            <Handle type="target" id="http-target" position={Position.Top} >
                <span className="handle-label top" >{ "Input" }</span>
            </Handle>
            <div className="node__layout">
                <div className="layout__top">
                    <span className="http-icon" />
                    <span className={ "label-span" }>
                        { type }
                    </span>
                </div>
                <div className="layout__middle">
                    <span className="label-span">{ "URL:" + url }</span>
                </div>
                <div className="layout__bottom">
                    <span className="label-span">{ (typeof data?.label === 'string' && data.label.length > 0) ? data.label : "HTTP Node" }</span>
                    <span className="action-span nodrag" onClick={ handleShowHTTPConfigurationClick }>
                        <SettingsIcon />
                    </span>
                </div>
            </div>
            <Handle
                type="source"
                position={Position.Bottom}
                id="http-source-error"
                style={ { left: '25%' } }
            >
                <span className="handle-label bottom" >{ "Output Error" }</span>
            </Handle>
            <Handle
                type="source"
                position={Position.Bottom}
                id="http-source-success"
                style={ { left: '75%' } }
            >
                <span className="handle-label bottom" >{ "Output Success" }</span>
            </Handle>
        </div>
    );
}

export default WorkflowHTTPNode;